<template>
  <div>
    <Notification :notify="notify" />
    <v-card class="d-flex pa-2 pb-2" outlined tile>
      <div class="row">
        <div class="col-8">
          <b>Publisher:</b> {{ PublisherName }} <b class="ml-10">File:</b>
          {{ FileName }}
        </div>
        <div class="col-4">
          <div class="float-right">
            <v-icon class="mr-2" @click="onRefresh()">mdi-cached</v-icon>
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="d-flex mt-2" outlined tile>
      <div class="row pa-2">
        <div class="col">
          <div class="float-left" style="width: 250px">
            <v-file-input
              accept=".csv"
              placeholder="Import CSV File"
              prepend-icon="mdi-file"
              label="Import CSV File"
              v-model="csvData"
              @change="loadCSV"
            ></v-file-input>
          </div>
        </div>
        <div class="col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onExport()" class="mt-4"
              >Export to CSV</v-btn
            >
            <div style="display: none">
              <download-csv
                ref="csv"
                class="btn btn-default"
                :data="exportData"
                name="Download.csv"
              >
                Download CSV
              </download-csv>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <div class="row mt-2">
      <div class="col">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 25px">
                  <v-checkbox
                    color="info"
                    class="check-select"
                    v-model="isSelectAll"
                    @click="onSelectAll()"
                  ></v-checkbox>
                </th>
                <th class="text-left">Title</th>
                <th class="text-left">ISBN</th>
                <th class="text-left">Author</th>
                <th class="text-left">Publisher</th>
                <th class="text-left">Year</th>
                <th class="text-left">City</th>
                <th class="text-left">Country</th>
                <!-- <th class="text-left">Summary</th> -->
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in listMataData" :key="item.id">
                <td>
                  <v-checkbox
                    v-model="item.isSelected"
                    @click="onSelect(item)"
                  ></v-checkbox>
                </td>
                <td>{{ item.Title }}</td>
                <td>{{ item.ISBN }}</td>
                <td>{{ item.Author }}</td>
                <td>{{ item.Publisher }}</td>
                <td>{{ item.PublishedYear }}</td>
                <td>{{ item.CityOfPublication }}</td>
                <td>{{ item.CountryOfPublication }}</td>
                <!--     <td>{{ item.Summary.substring(0, 10) + "..." }}</td> -->
                <td>
                  <v-icon class="mr-2 icon-edit" dark @click="onEdit(item)"
                    >mdi-comment-edit</v-icon
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <Pagination :paging="paging" v-on:next="onNextPage" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="float-right">
          <v-btn color="primary" @click="onReview()" class="mt-4">Review</v-btn>
        </div>
      </div>
    </div>
    <ImportPublicationDialog ref="updateDialog" />
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import ImportPublicationDialog from "@/components/ImportPublicationDialog";
import ImportCsvData from "./../model/ImportCsvData";

const { Parser } = require("json2csv");
const csv = require("csvtojson");

export default {
  name: "ImportPublicationList",
  props: {
    FileId: { type: Number, required: true },
    FileName: { type: String, required: true },
    PublisherName: { type: String, required: true },
    step: { type: Number, required: true },
  },
  watch: {
    FileName: function (val) {
      //console.log("val " + val);
      //this.FileName = val;
      //if (this.FileName != "") this.getMetadata(val);
    },
    FileId: function (val) {},
    step: function (val) {
      console.log("step val " + val);
      if (val != "" && val != 0 && val == 3) this.getMetadata(this.FileId);
    },
  },
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    ImportPublicationDialog,
  },
  created() {},
  methods: {
    onSelectAll() {
      new Promise((resolve, reject) => {
        api
          .put("import/onix/metadata/" + this.FileId +"/selectAll/" + this.isSelectAll,  {FileId:this.FileId})
          .then((response) => {
            console.log("onSelectAll " + response.data);
            this.getMetadata(this.FileId);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelect(item) {
      new Promise((resolve, reject) => {
        api
          .put(
            "import/onix/metadata/" + item.id + "/select/" + item.isSelected,
            {FileId:this.FileId}
          )
          .then((response) => {
            console.log("onSelect " + response.data);
            this.getMetadata(this.FileId);
          })
          .catch((error) => {
            reject(error);
          });
      });

      console.log(item.id);
      console.log(item.isSelected);
    },
    onRefresh() {
      this.getMetadata(this.FileId);
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getMetadata(this.FileId);
    },
    getMetadata(fileId) {
      console.log("getMetadata " + fileId);
      this.listMataData = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("import/onix/metadata/" + fileId, this.paging)
          .then((response) => {
            // this.listMataData = response.data;
            console.log("getByPagin " + response.data);

            this.listMataData = response.data.data;
            this.paging.count = response.data.count;
            console.log(this.listMataData);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getMetadata(this.FileId);
    },
    onExport() {
      new Promise((resolve, reject) => {
        api
          .getAll("import/onix/metadata/selected/" + this.FileId)
          .then((response) => {
            this.exportData = response.data;
            this.downloadCSV(this.exportData);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    downloadCSV(json) {
      const fields = [
        // "id",
        "isSelected",
        "isMetaDataOnly",
        "ISBN",
        "Title",
        "Author",
        "Summary",
        "Thumbnail",
        "Publisher",
        "CityOfPublication",
        "CountryOfPublication",
        "PublishedYear",
        "keywords",
        "listprice",
        "discount",
        "countries_allowed",
        "bisac",
        "lcc",
        "dewey",
        "language",
        "contributorRole1",
        "contributor1",
        "contributorRole2",
        "contributor2",
        "contributorRole3",
        "contributor3",
        "contributorRole4",
        "contributor4",
        "contributorRole5",
        "contributor5",
        "contributorRole6",
        "contributor6",
        "contributorRole7",
        "contributor7",
        "contributorRole8",
        "contributor8",
        "contributorRole9",
        "contributor9",
        "contributorRole10",
        "contributor10",
      ];
      const opts = { fields };

      const parser = new Parser(opts);
      const csv = parser.parse(json);

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        this.FileName.replace("xml", "csv").replace("xlsx", "csv")
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    loadCSV(file) {
      this.listMataData = [];
      let result = [];

      const reader = new FileReader();
      if (this.csvData != null) {
        reader.readAsText(this.csvData);
        reader.onload = (resultCSV) => {
          var csvData = resultCSV.currentTarget.result;
          var json = this.csvToJSON3(csvData);
          console.log(json);
        };
        reader.readAsDataURL(file);
      }
    },
    csvToJSON(csvText) {
      let lines = [];
      const linesArray = csvText.toString().split("\n");
      // for trimming and deleting extra space
      linesArray.forEach((e) => {
        const row = e.replace(/[\s]+[,]+|[,]+[\s]+/g, ",").trim();
        lines.push(row);
      });
      // for removing empty record
      lines.splice(lines.length - 1, 1);
      const result = [];
      const headers = lines[0].split(",");

      for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentline = lines[i].split(",");

        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }
        result.push(obj);
      }
      //return result; //JavaScript object
      // return JSON.stringify(result); //JSON
      return result;
    },
    csvToJSON2(csvText) {
      // console.log(csvText);

      //Split all the text into seperate lines on new lines and carriage return feeds
      var allTextLines = csvText.split(/\r\n|\n/);
      //Split per line on tabs and commas
      var headers = allTextLines[0].split(/\t|,/);
      var lines = [];
      var locations = [];

      console.log("allTextLines " + allTextLines.length);

      for (var i = 1; i < allTextLines.length; i++) {
        let data = allTextLines[i].split(/\t|,/).toString();

        console.log("data " + data);

        //data = data.replace('""/g','')

        console.log("data.length " + data.length);
        console.log("headers.length " + headers.length);

        if (data.length == headers.length) {
          var location = {
            id: data[0],
            isSelected: data[1],
            isMetaDataOnly: data[2],
            ISBN: data[3],
            Title: data[4],
            Author: data[5],
            Summary: data[6],
            Thumbnail: data[7],
            Publisher: data[8],
            CityOfPublication: data[9],
            CountryOfPublication: data[10],
            PublishedYear: data[11],
            keywords: data[12],
            listprice: data[13],
            discount: data[14],
            countries_allowed: data[15],
            bisac: data[16],
            lcc: data[17],
            dewey: data[18],
            language: data[19],
            contributorRole1: data[20],
            contributor1: data[21],
            contributorRole2: data[22],
            contributor2: data[23],
            contributorRole3: data[24],
            contributor3: data[25],
            contributorRole4: data[26],
            contributor4: data[27],
            contributorRole5: data[28],
            contributor5: data[29],
            contributorRole6: data[30],
            contributor6: data[31],
            contributorRole7: data[32],
            contributor7: data[33],
            contributorRole8: data[34],
            contributor8: data[35],
            contributorRole9: data[36],
            contributor9: data[37],
            contributorRole10: data[38],
            contributor10: data[39],
          };
          locations.push(location);
        }
      }
      return locations;
    },
    csvToJSON3(csvData) {
      this.csvRowList = [];
      csv({
        noheader: true,
        output: "csv",
      })
        .fromString(csvData)
        .then((csvRows) => {
          var csvRowData = csvRows;

          for (var i = 1; i < csvRowData.length; i++) {
            var data = csvRowData[i];

            var row = new ImportCsvData();
            row.id = data[0];
            (row.isSelected = data[1]),
              (row.isMetaDataOnly = data[2]),
              (row.ISBN = data[3]),
              (row.Title = data[4]),
              (row.Author = data[5]),
              (row.Summary = data[6]),
              (row.Thumbnail = data[7]),
              (row.Publisher = data[8]),
              (row.CityOfPublication = data[9]),
              (row.CountryOfPublication = data[10]),
              (row.PublishedYear = data[11]),
              (row.keywords = data[12]),
              (row.listprice = data[13]),
              (row.discount = data[14]),
              (row.countries_allowed = data[15]),
              (row.bisac = data[16]),
              (row.lcc = data[17]),
              (row.dewey = data[18]),
              (row.language = data[19]),
              (row.contributorRole1 = data[20]),
              (row.contributor1 = data[21]),
              (row.contributorRole2 = data[22]),
              (row.contributor2 = data[23]),
              (row.contributorRole3 = data[24]),
              (row.contributor3 = data[25]),
              (row.contributorRole4 = data[26]),
              (row.contributor4 = data[27]),
              (row.contributorRole5 = data[28]),
              (row.contributor5 = data[29]),
              (row.contributorRole6 = data[30]),
              (row.contributor6 = data[31]),
              (row.contributorRole7 = data[32]),
              (row.contributor7 = data[33]),
              (row.contributorRole8 = data[34]),
              (row.contributor8 = data[35]),
              (row.contributorRole9 = data[36]),
              (row.contributor9 = data[37]),
              (row.contributorRole10 = data[38]),
              (row.contributor10 = data[39]),
              /*
            var row = {
              id: data[0],
              isSelected: data[1],
              isMetaDataOnly: data[2],
              ISBN: data[3],
              Title: data[4],
              Author: data[5],
              Summary: data[6],
              Thumbnail: data[7],
              Publisher: data[8],
              CityOfPublication: data[9],
              CountryOfPublication: data[10],
              PublishedYear: data[11],
              PublishedYear: data[12],
              isImported: data[13],
              keywords: data[14],
              listprice: data[15],
              discount: data[16],
              countries_allowed: data[17],
              bisac: data[18],
              lcc: data[19],
              dewey: data[20],
              language: data[21],
              contributorRole1: data[22],
              contributor1: data[23],
              contributorRole2: data[24],
              contributor2: data[25],
              contributorRole3: data[26],
              contributor3: data[27],
              contributorRole4: data[28],
              contributor4: data[30],
              contributorRole5: data[31],
              contributor5: data[32],
              contributorRole6: data[33],
              contributor6: data[34],
              contributorRole7: data[35],
              contributor7: data[36],
              contributorRole8: data[37],
              contributor8: data[38],
              contributorRole9: data[39],
              contributor9: data[40],
              contributorRole10: data[41],
              contributor10: data[42],
            };*/
              //console.log(row)
              this.csvRowList.push(row);
          }
          // console.log(JSON.stringify(this.csvRowList));
          this.onUploadCSVData(this.csvRowList);
        });
      return this.csvRowList;
    },
    onUploadCSVData(obj) {
      console.log(obj);
      new Promise((resolve, reject) => {
        api
          .post("import/onix/file/import/csv/" + this.FileId, obj)
          .then((response) => {
            console.log("onUploadCSVData " + response.data);
            this.getMetadata(this.FileId);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onReview(obj) {
      this.$emit("onReview", this.listMataData);
    },
    onEdit(item) {
      if (this.$refs.updateDialog.open("ISBN: " + item.ISBN, "",null, item)) {}
    },
  },
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      listMataData: [],
      exportData: [],
      csvData: {},
      csvRowList: [],
      csvJSON: "",
      importData: {},
      isSelectAll: false,
      Search: "",
      dialog: false,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ImportPublicationList.vue